import { createRouter, createWebHashHistory, RouterView } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import i18n from '../plugins/i18n'
// let locale = i18n.locale;
const routes = [
  {
    path: '/',
    redirect: `/${i18n.global.locale}`,
  },
  {
    path: '/:lang',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView
      },
      {
        path: 'video',
        name: 'video',
        component: () => import(/* webpackChunkName: "about" */ '../views/VideoView.vue')
      },
      // {
      //   path: '/modderList',
      //   component: () => import('../views/ModderList.vue')
      // },
      {
        path: 'modderView/:modderId',
        component: () => import('../views/ModderView.vue')
      },
      {
        path: 'newsList',
        component: () => import('../views/NewsList.vue')
      },
      {
        path: 'newsView/:newsId',
        component: () => import('../views/NewsView.vue')
      },
      {
        path: 'rulesPrizes',
        component: () => import('../views/RulesPrizes.vue')
      },
      {
        path: 'judge',
        component: () => import('../views/Judge.vue')
      },
      {
        path: 'winner',
        component: () => import('../views/Winner.vue')
      },
      {
        path: 'voteNow',
        component: () => import('../views/VoteNow.vue')
      }
    ]
  },
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const langs = to.params.lang;
  console.log('在 router', to.params.lang, 'i18n.locale', i18n.global.locale, '$route', from.params.lang);
  // if(!i18n.global.locale.includes(langs)) {
  //   // return next('en')
  // }
  if(!langs) {
    langs = 'en'
  }

  // if(i18n.locale !== lang) {
  //   i18n.locale = lang;
  // }
  // e04，(i18n.global.locale) 這個找超久.....，可以控制 i18n.js 裡面的 locale
  // 在這邊用 i18n.global.locale，如果在 vue 檔案裡面就可以用 this.$i18n.locale
  i18n.global.locale = langs;
  
  next();
})

export default router
